import apiSlice from '../../services/api/slice'
import { TAGS } from '../../constants/tags'

const prospectsSlice = apiSlice.injectEndpoints({
  name: 'prospects',
  endpoints: (builder) => ({
    getProspects: builder.query({
      queryFn: async (_arg, _queryApi, _extraOptions, baseQuery) => {
        async function fetchProspects(nextId) {
          try {
            const result = await baseQuery({
              url: `/v1/admin/prospects${nextId ? `?nextId=${encodeURIComponent(nextId)}` : ''}`,
            })
            if (result.error) throw result.error

            const { data } = result.data
            if (data.nextId) {
              const nextData = await fetchProspects(data.nextId)
              return { ...data, prospects: [...data.prospects, ...nextData.prospects] }
            }
            return data
          } catch (error) {
            return { error }
          }
        }

        const response = await fetchProspects()
        return { data: response.prospects }
      },
      providesTags: [TAGS.PROSPECTS],
    }),
    assignProspectsToCampaign: builder.mutation({
      query: ({ prospectIds, campaignId, userId, producerId }) => ({
        url: `/v1/admin/prospects/assign`,
        method: 'POST',
        body: { prospectIds, campaignId, userId, producerId },
      }),
      invalidatesTags: [TAGS.PROSPECTS],
    }),
    unassignProspectsFromCampaign: builder.mutation({
      query: ({ prospectIds, campaignId }) => ({
        url: `/v1/admin/prospects/unassign`,
        method: 'POST',
        body: { prospectIds, campaignId },
      }),
      invalidatesTags: [TAGS.PROSPECTS],
    }),
    deleteProspects: builder.mutation({
      query: ({ prospectIds }) => ({
        url: `/v1/admin/prospects`,
        method: 'DELETE',
        body: { prospectIds },
      }),
      invalidatesTags: [TAGS.PROSPECTS],
    }),
  }),
})

export const {
  useGetProspectsQuery,
  useAssignProspectsToCampaignMutation,
  useUnassignProspectsFromCampaignMutation,
  useDeleteProspectsMutation,
} = prospectsSlice
export default prospectsSlice
